export const emailRegExpFormat =
  /^(?:[A-Za-z0-9_%+-]+(?:\.[A-Za-z0-9_%+-]+)*)@(?:(?!-)[A-Za-z0-9-]{1,63}(?<!-)\.)+[A-Za-z]{2,}$/

export const isEmailValid = (input) => {
  return emailRegExpFormat.test(input)
}
